$(document).ready(function (){

    $("#table-barcode").dataTable({
        'processing': true,
        'serverSide': true,
        'ajax': '/get-barcode-items',
        'columns': [{data: 'id'}, {data: 'item_code'}, {data: 'unit'}, {data: 'barcode'},],
        "columnDefs": [
            {
                "targets": 4,
                "render": function (data, type, row, meta) {
                    btn_edit_item = buttonEditItem(row.id,row.status)
                    return btn_edit_item
                }
            }],
        "language": {
            "url": "//cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json"
        },
    })


    $("#add-item").on('click', function (e){
        e.preventDefault()
        $(".modal-title").html("Agregar código")
        $("#modal-barcode").modal('show')
    })

    $("#form-barcode").on('submit', function (e){
        e.preventDefault();
        let data = new FormData(this)
        sendData(data,"/barcode.add",'modal-barcode')
    })

    function sendData(data, route, modal) {
        $(".loader_").addClass('loading')
        $.ajax({
            url: route, type: 'POST', data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {
                console.log(response)
                setTimeout(function () {
                    alertSuccess(response.msg)
                    $("#"+modal).modal('hide')
                    $("#table-barcode").DataTable().ajax.reload();
                    $(".loader_").removeClass('loading')
                }, 1000)
            }, error: function (errors, xhr, status,) {
                $(".loader_").removeClass('loading')
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-error-" + index).text(value);
                });
            }
        });
    }

    function buttonEditItem(id,status_id) {
            return '<button data-toggle="tooltip" data-placement="top" title="Editar tarea" ' +
                'class="btn btn-primary edit-task btn-sm m-1"' + 'data-id ="' + id + '">' +
                '<i class="far fa-edit"></i>' +
                '</button>'

    }

})
